/**
 * Created by Karol Kluska on 26.06.17.
 */

angular
  .module('app')
  .component('modalSimple', {
    templateUrl: 'app/shared/modalSimple/ModalSimple.html',
    controller: ModalSimple,
    bindings: {
      resolve: '<',
      close: '&'
    }
  });

function ModalSimple($sce) {
  var $this = this;
  $this.$sce = $sce;
}

ModalSimple.prototype = {
  $onInit: function () {
    this.title = this.resolve.title;
    this.description = this.$sce.trustAsHtml(this.resolve.description) || '';
  },

  handleClose: function () {
    this.close();
  }
};
